import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { deleteAttachmentsBulk } from '../query-api'

interface UseDeleteDuplicateProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useDeleteDuplicate = (props?: UseDeleteDuplicateProps) => {
  const { onError, onSuccess } = props || {}
  const queryClient = useQueryClient()

  const { mutate: deleteDuplicate, ...rest } = useMutation(
    (attachmentId: string) => deleteAttachmentsBulk([attachmentId]),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.AttachmentsList)
        onSuccess?.()
      },
      onError: (error?: APIError) => {
        onError?.(error)
      },
    },
  )

  return { deleteDuplicate, ...rest }
}
